export { default } from './svg/camera.svg';
